import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const Navbar = () => {
  const [navbarData, setNavbarData] = useState({
    logo: '',
    logo2: "",
    bgColor: '#ffffff', 
    textColor: '#000000', 
    buttonBgColor: '#007BFF',
    buttonTextColor: '#ffffff',
  });

  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
        window.scrollTo(0, 0);  // Scroll to the top when the route changes
    }, 0);
}, [location]);


  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
  const apiUrl = import.meta.env.VITE_API_URL;
  const [servicesData,setServicesData] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
        try {
            const res = await fetch(`${apiUrl}/get-service-slugs/`);
            const data = await res.json();
            setServicesData(data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/layout/navbar/`)
      .then((res) => res.json())
      .then((data) => setNavbarData(data))
      .catch((error) => console.error('Error loading navbar configuration:', error));
  }, []);

  const routes = [
    { label: 'HOME', path: '/' },
    { label: 'ABOUT', path: '/about' },
    { label: 'REGISTRATION', path: '',
      subItems:[
        { label:"Worker Registration", path:"/worker-registration" },
        { label:"Apply for Jobs Now", path:"/apply-jobs-now" },
        { label:"Agent Registration", path:"/agent-registration" },
      ]
    },
    { label: 'MEDICAL REPORT', path: '/medical-report' },
    { label: 'DEMAND SUBMISSION', path: '/demand-submission' },
    { label: 'TRAINING', path: '/training' },
    { label: 'GALLERY', path: '/gallery' },
  ];

  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const toggleSubMenu = (index) => {
    setOpenSubMenuIndex(openSubMenuIndex === index ? null : index);
  };

  const closeMenu = () => setIsMenuOpen(false);

  const handleItemClick = () => {
    closeMenu();  // Close the menu when an item is clicked
    setOpenSubMenuIndex(null);  // Close the submenu when an item is clicked
    window.scrollTo(0, 0);  // Scroll to the top of the page
  };
  

  return (
    <nav
      className="sticky top-0 z-50 shadow-lg font-extrabold p-5"
      style={{ backgroundColor: navbarData.bgColor, color: navbarData.textColor }}
    >
      <div className="container mx-auto px-4 py-2 flex gap-10 items-center justify-between">
        <Link to="/" className="flex items-center" onClick={handleItemClick}>
          <div className="w-32 h-12 p-5 flex items-center justify-center bg-white rounded-lg">
            <img
              src={navbarData.logo}
              alt="Logo"
              className="object-center object-contain"
            />
          </div>
        </Link>

        <button
          className="lg:hidden text-3xl"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          ☰
        </button>

        <div
          className={`p-2 lg:p-0 absolute lg:static top-16 right-2 w-1/2 lg:w-auto bg-black border-2 lg:border-0 border-alf rounded-xl lg:bg-transparent shadow-md lg:shadow-none transition-all duration-300 ${
            isMenuOpen ? 'block' : 'hidden'
          } lg:flex items-center`}
        >
          <ul className="flex flex-col lg:flex-row gap-4 xl:gap-10  p-1   whitespace-nowrap text-xs xl:text-sm">
            {routes.map((route, index) => (
              <li key={index} className="relative group">
                {route.subItems ? (
                  <>
                    <div
                      className="cursor-pointer hover:text-yellow-600 flex items-center lg:hover:text-yellow-600"
                      onClick={() => toggleSubMenu(index)}
                    >
                      <div onMouseEnter={() => toggleSubMenu(index)}>
                        {route.label}
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 ml-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                      </svg>
                    </div>
                    <ul
                      className={`absolute  top-8 border-2 border-yellow-300 bg-black shadow-md rounded-md p-2 w-48 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-200 z-10 ${
                        openSubMenuIndex === index ? 'block' : 'hidden'
                      }`}
                      onMouseLeave={() => toggleSubMenu(index)}
                    >
                      {route.subItems.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          className="py-1 px-2 hover:bg-gray-100 rounded"
                        >
                          <a
                            href={subItem.path}
                            style={{ color: navbarData.textColor }}
                            onClick={handleItemClick}
                          >
                            {subItem.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link
                    to={route.path}
                    className="hover:text-blue-600"
                    
                    style={{ color: navbarData.textColor }}
                    onClick={handleItemClick}
                  >
                    {route.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        <a target ="_blank" href="https://stechgroupbd.com/" className="hidden lg:flex items-center rounded-xl">
          <div className="bg-white rounded-lg w-28 h-12 flex items-center justify-center">
            <img
              src={navbarData.logo2}
              alt="Logo"
              className="object-center object-contain "
            />
          </div>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
